
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import OwcDataComponent from '@owc-utils/Mixins/OwcDataComponent';
import SlotContainer from '@owc-packages/SlotContainer/src/SlotContainer.vue';
import { MediaSliderComponent, Payload } from './MediaSlider';
import MediaSliderItem from '@owc-packages/MediaSlider/src/MediaSliderItem.vue';
import ValidationBoxWrapper from '@owc-packages/ValidationBox/src/ValidationBoxWrapper.vue';
import { mobileBreakpoints } from '@owc-utils/MediaQueryService';
import { getComponentStateConnection } from '@owc-utils/Store/owcComponent';
import { getLocalFootnotes, setModuleId } from '@owc-utils/Footnotes/FootnotesHelper';

export default (ComponentInitializeDispatcher as MediaSliderComponent).extend({
  name: 'owc-media-slider',
  mixins: [OwcDataComponent],
  components: {
    MediaSliderItem,
    SlotContainer,
    ValidationBoxWrapper,
  },
  data: () => ({
    indexSlider: 0,
    isMobile: false,
    mediaSliderItemsIds: [],
  }),
  created() {
    this.isOnMobileView();
    this.onMQChange?.(() => {
      this.isOnMobileView();
      this.calculateActiveSlides();
    });
  },
  mounted() {
    this.generateMediaSliderItemsIdsArray();
  },
  computed: {
    sliderItems() {
      return this.componentData?.items;
    },
    isDarkMode: function() {
      return Boolean(this.componentData?.darkMode);
    },
    footnotes() {
      return getLocalFootnotes(this.componentData);
    },
    moduleId() {
      return setModuleId(this);
    },
  },
  methods: {
    sliderChanged(event) {
      const videoPlayerItems = Array.from(
        this.getHost().querySelectorAll('owc-media-slider owc-video-player'),
      );
      this.indexSlider = event.detail - 1;
      videoPlayerItems.forEach(videoPlayer => {
        const playButton = videoPlayer.shadowRoot?.querySelector(
          '.plyr--playing button[data-plyr="play"]',
        ) as HTMLButtonElement;
        if (playButton) {
          playButton.click();
        }
      });
      this.calculateActiveSlides();
    },
    async calculateActiveSlides() {
      const connection = await getComponentStateConnection();
      const payload: Payload[] = this.mediaSliderItemsIds.map((item, index) => ({
        id: item,
        json: {
          isActive: this.itemIsActive(index),
        },
      }));
      connection.updateComponents(payload);
    },
    isOnMobileView() {
      const currentMq = this.getCurrentMediaQuery?.();
      this.isMobile = Boolean(currentMq && mobileBreakpoints.includes(currentMq));
    },
    itemIsActive(index) {
      return index === this.indexSlider || (!this.isMobile && index === this.indexSlider + 1);
    },
    generateMediaSliderItemsIdsArray() {
      const host = this.getHost();

      if (host) {
        const mediaSliderItems = Array.from(host.querySelectorAll('owc-media-slider-item'));
        this.mediaSliderItemsIds = mediaSliderItems
          .map(item => item.getAttribute('component-id') as string)
          .filter(item => item);
      }
    },
  },
});
